var map = {
	"./analytics-o2o.svg": 92138,
	"./base-management.svg": 9113,
	"./campaigns.svg": 71854,
	"./cashback.svg": 62145,
	"./data-and-integrations.svg": 64213,
	"./email.svg": 87405,
	"./help.svg": 62109,
	"./oto-academy.svg": 24698,
	"./settings.svg": 91181,
	"./sms.svg": 97771,
	"./store-team-management.svg": 81211
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71818;